/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_CHROME_WINDOWS_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 0,
  userAgent:
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.102 Safari/537.36',
  userAgentData: {
    brands: [
      { brand: 'Not A;Brand', version: '99' },
      { brand: 'Chromium', version: '98' },
      { brand: 'Google Chrome', version: '98' },
    ],
    mobile: false,
    platform: 'Windows',
  },
  vendor: 'Google Inc.',
  platform: 'Win32',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_FIREFOX_WINDOWS_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 0,
  userAgent: 'Mozilla/5.0 (Windows NT 10.0; Win64; x64; rv:93.0) Gecko/20100101 Firefox/93.0',
  userAgentData: undefined,
  vendor: '',
  platform: 'Win32',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_FIREFOX_IPHONE_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 1,
  userAgent:
    'Mozilla/5.0 (iPhone; CPU iPhone OS 14_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) FxiOS/122.0 Mobile/15E148 Safari/605.1.15',
  userAgentData: undefined,
  vendor: 'Apple Computer, Inc',
  platform: 'iPhone',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_EDGE_WINDOWS_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 0,
  userAgent:
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/99.0.4844.51 Safari/537.36 Edg/99.0.1150.39',
  userAgentData: {
    brands: [
      { brand: 'Not A;Brand', version: '99' },
      { brand: 'Chromium', version: '99' },
      { brand: 'Microsoft Edge', version: '99' },
    ],
    mobile: false,
    platform: 'Windows',
  },
  vendor: 'Google Inc.',
  platform: 'Win32',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_IE_WINDOWS_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 0,
  userAgent:
    'Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; .NET CLR 2.0.50727; .NET CLR 3.0.30729; .NET CLR 3.5.30729; itx; wbx 1.0.0; rv:11.0) like Gecko',
  userAgentData: undefined,
  vendor: '',
  platform: 'Win32',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_CHROME_ANDROID_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 1,
  userAgent:
    'Mozilla/5.0 (Linux; Android 11; Mi A3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/99.0.4844.58 Mobile Safari/537.36',
  userAgentData: {
    brands: [
      { brand: 'Not A;Brand', version: '99' },
      { brand: 'Chromium', version: '98' },
      { brand: 'Google Chrome', version: '99' },
    ],
    mobile: true,
    platform: 'Android',
  },
  vendor: 'Google Inc.',
  platform: 'Linux armv8l',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_CHROME_MAC_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 0,
  userAgent:
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/99.0.4844.51 Safari/537.36',
  userAgentData: {
    brands: [
      { brand: 'Not A;Brand', version: '99' },
      { brand: 'Chromium', version: '98' },
      { brand: 'Google Chrome', version: '99' },
    ],
    mobile: false,
    platform: 'macOS',
  },
  vendor: 'Google Inc.',
  platform: 'MacIntel',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_SAFARI_MAC_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 0,
  userAgent:
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.1.2 Safari/605.1.1',
  userAgentData: undefined,
  vendor: 'Apple Computer, Inc',
  platform: 'MacIntel',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_SAFARI_MAC_NAVIGATOR_15: Partial<Window['navigator']> = {
  maxTouchPoints: 0,
  userAgent:
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.6.1 Safari/605.1.15',
  userAgentData: undefined,
  vendor: 'Apple Computer, Inc.',
  platform: 'MacIntel',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_SAFARI_IPHONE_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 5,
  userAgent:
    'Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1',
  userAgentData: undefined,
  vendor: 'Apple Computer, Inc',
  platform: 'iPhone',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_CHROME_IPHONE_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 5,
  userAgent:
    'Mozilla/5.0 (iPhone; CPU iPhone OS 14_7 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/96.0.4664.53 Mobile/15E148 Safari/604.1',
  userAgentData: undefined,
  vendor: 'Apple Computer, Inc',
  platform: 'iPhone',
};

export const MOCK_SAFARI_IPHONE_IOS17_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 5,
  userAgent:
    'Mozilla/5.0 (iPhone; CPU iPhone OS 17_2_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.2.1 Mobile/15E148 Safari/604.1',
  userAgentData: undefined,
  vendor: 'Apple Computer, Inc',
  platform: 'iPhone',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_CHROME_IPHONE_IOS17_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 5,
  userAgent:
    'Mozilla/5.0 (iPhone; CPU iPhone OS 17_2_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/96.0.4664.53 Mobile/15E148 Safari/604.1',
  userAgentData: undefined,
  vendor: 'Apple Computer, Inc',
  platform: 'iPhone',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_SAFARI_IPAD_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 5,
  userAgent:
    'Mozilla/5.0 (iPad; CPU OS 17_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.2 Mobile/15E148 Safari/604.1',
  userAgentData: undefined,
  vendor: 'Apple Computer, Inc',
  platform: 'iPad',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_CHROME_IPAD_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 5,
  userAgent:
    'Mozilla/5.0 (iPad; CPU OS 17_3 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) CriOS/121.0.6167.66 Mobile/15E148 Safari/604.1',
  userAgentData: undefined,
  vendor: 'Apple Computer, Inc',
  platform: 'iPad',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_SAFARI_IPAD_13_NAVIGATOR: Partial<Window['navigator']> = {
  maxTouchPoints: 5,
  userAgent:
    'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_4) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.1.1 Safari/605.1.15',
  userAgentData: undefined,
  vendor: 'Apple Computer, Inc',
  platform: 'iPad',
};

/**
 * @category Platform
 *
 * @ignore
 */
export const MOCK_UNKNOWN_PLATFORM: Partial<Window['navigator']> = {
  maxTouchPoints: 5,
  userAgent: 'unknown',
  userAgentData: undefined,
  vendor: 'unknown',
  platform: 'unknown',
};
